import React from 'react';
import { Button, Chip, Paper, Stack, Tooltip, Typography } from '@mui/material';
import type { ObservableFeature, SpecimenFeatureProfile } from './specimenFeatures';
import type { ObservationTool } from './SpecimenViewer';

interface FeatureHighlighterProps {
  profile: SpecimenFeatureProfile;
  tool: ObservationTool;
  observed: Record<string, boolean>;
  onToggle: (feature: ObservableFeature) => void;
}

const FeatureHighlighter: React.FC<FeatureHighlighterProps> = ({ profile, tool, observed, onToggle }) => (
  <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1 }}>
    <Typography variant="subtitle1" fontWeight={800}>Observable features</Typography>
    <Typography variant="caption" color="text.secondary">Select a feature only after observing it with an appropriate tool. Reference-only traits require a reliable reference source.</Typography>
    <Stack spacing={0.75} sx={{ mt: 1 }}>
      {profile.features.map((item) => <Stack key={item.id} direction="row" spacing={1} alignItems="center" justifyContent="space-between">
        <Tooltip title={`${item.description} Observation tool: ${item.tool.replaceAll('-', ' ')}.`} arrow><Typography variant="body2">{item.label}</Typography></Tooltip>
        <Stack direction="row" spacing={0.5} alignItems="center"><Chip size="small" variant="outlined" label={item.tool.replaceAll('-', ' ')} /><Button size="small" variant={observed[item.id] ? 'contained' : 'outlined'} disabled={item.tool !== 'reference' && item.tool !== tool && !(item.tool === 'hand-lens' && tool !== 'compound-microscope')} onClick={() => onToggle(item)} aria-pressed={observed[item.id]}>{observed[item.id] ? 'Recorded' : 'Observe'}</Button></Stack>
      </Stack>)}
    </Stack>
  </Paper>
);

export default FeatureHighlighter;
